import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5c3b38bc&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3b38bc')) {
      api.createRecord('5c3b38bc', component.options)
    } else {
      api.reload('5c3b38bc', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5c3b38bc&", function () {
      api.rerender('5c3b38bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24N98mfpOBa4T/JS/comp/openstreetmap.vue"
export default component.exports